









































import { Component, Prop, Vue } from "vue-property-decorator";
import Navlink from "../models/Navlink";

@Component
export default class NavigationComponent extends Vue {
  public navLinks: Navlink[] = [];

  public closeMenuOnTap() {
    const toggler = document.getElementById("toggler") as HTMLInputElement;
    toggler!.checked = false;
  }

  public switchLanguage(language: string) {
    if (this.$i18n.locale !== language) {
      this.$i18n.locale = language;
    }
  }

  public created() {
    this.navLinks = [
      new Navlink(1, "home", "#home", "current"),
      new Navlink(2, "profile", "#profile-section", ""),
      new Navlink(3, "curriculum", "#curriculum-section", ""),
      new Navlink(4, "skills", "#skills-section", ""),
      new Navlink(5, "work", "#work-section", ""),
      new Navlink(6, "recommendations", "#recommendations-section", ""),
      new Navlink(7, "contact", "#contact-section", "")
    ];
  }
}
